import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=a156fa0a&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=a156fa0a&lang=less&scoped=true&"
import style1 from "./Step2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156fa0a",
  null
  
)

export default component.exports